import { render, staticRenderFns } from "./input-text.vue?vue&type=template&id=12a8ff7a"
import script from "./input-text.vue?vue&type=script&lang=js"
export * from "./input-text.vue?vue&type=script&lang=js"
import style0 from "./input-text.vue?vue&type=style&index=0&id=12a8ff7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports